(function () {
  document.querySelectorAll('[data-strikeman-product-page] [data-spp-gallery]').forEach(function (gallery) {
    var startX = 0;
    var startY = 0;
    var lastX = 0;
    var lastY = 0;
    var tracking = false;

    gallery.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1 || !event.target.closest('video')) return;
      var touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      lastX = startX;
      lastY = startY;
      tracking = true;
    }, { passive: true, capture: true });

    gallery.addEventListener('touchmove', function (event) {
      if (!tracking || !event.touches.length) return;
      var touch = event.touches[0];
      lastX = touch.clientX;
      lastY = touch.clientY;
    }, { passive: true, capture: true });

    gallery.addEventListener('touchend', function () {
      if (!tracking) return;
      var deltaX = lastX - startX;
      var deltaY = lastY - startY;
      tracking = false;

      if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;

      var selector = deltaX < 0 ? '[data-spp-gallery-next]' : '[data-spp-gallery-prev]';
      var control = gallery.querySelector(selector);
      if (control) control.click();
    }, { passive: true, capture: true });
  });
})();
